import { useEffect, useState } from "react";
import {
  fetchFromLocalStorage,
  saveToLocalStorage,
} from "../Helpers/LocalStorage";

const useLocalStorageState = (key, initialValue) => {
  const [value, setValue] = useState(
    fetchFromLocalStorage(key) ? fetchFromLocalStorage(key) : initialValue
  );

  useEffect(() => {
    saveToLocalStorage(key, value);
  }, [value]);

  return [value, setValue];
};

export default useLocalStorageState;
